<template>
  <div class="sign-page">
    <div class="emtry-container" v-show="rotateType"></div>
    <div class="content" v-if="rotateType">
      <p class="title">
        请规范签写本人姓名 
        <van-icon name="cross" class="close-icon" @click="colseSign" />
      </p>
      <div class="sign-wrap" id="signWrap">
        <canvas id="myCanvas" v-if="rotateType"></canvas>
      </div>
      <div class="fix-btn flexC">
        <i class="fullScreen" @click="switchScreen"></i>
        <div class="clear-btn btn-item" @click="clearArea()">清除</div>
        <div class="comfirm-btn btn-item" @click="saveSign()">提交</div>
      </div>
    </div>
    <div class="horizontalScreen content" v-else>
      <div class="title">
        <p class="txt">
          请规范签写本人姓名
          <van-icon name="cross" class="close-icon" @click="colseSign" />
        </p>
      </div>
      <div class="sign-container">
        <div class="sign-wrap" id="signWrap">
          <canvas id="myCanvas" v-if="!rotateType"></canvas>
        </div>
      </div>
      <div class="bottom-btn">
        <div class="fix-btn flexC">
          <i class="fullScreen" @click="switchScreen"></i>
          <div class="clear-btn btn-item" @click="clearArea()">清除</div>
          <div class="comfirm-btn btn-item" @click="saveSign()">提交</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import * as marketService from "../marketService";

export default {
  data() {
    return {
      rotateType: true,
      image: "",
      mousePressed: false,
      c: "",
      ctx: "",
      lastX: 0,
      lastY: 0,
    };
  },
  mounted() {
    // console.log("mounted");
    this.image = "";
    this.mousePressed = false;
    var lastX, lastY;
    this.ctx = document.getElementById("myCanvas").getContext("2d");
    this.c = document.getElementById("myCanvas");
    var signWrap = document.getElementById("signWrap");
    this.c.style.display = 'block'
    this.c.width = signWrap.clientWidth; //设置宽度
    this.c.height = signWrap.clientHeight; //设置高度

    //监听touchstart事件，touchmove事件，touchend事件等事件
    this.InitThis();
  },
  methods: {
    // 切换横屏 竖屏
    switchScreen(){
      this.c.style.display = 'none'
      this.rotateType = !this.rotateType;
      setTimeout(()=>{
        this.lastX = 0;
        this.lastY = 0;
        // console.log("mounted");
         this.image = "";
        this.mousePressed = false;
        var lastX, lastY;
        let clientWidth = document.getElementById("signWrap").clientWidth;
        var signWrap = document.getElementById("signWrap");
        setTimeout(()=>{
          this.ctx = document.getElementById("myCanvas").getContext("2d");
          this.c = document.getElementById("myCanvas");
          this.c.style.display = 'block'
          this.c.width = clientWidth; //设置宽度
          this.c.height = signWrap.clientHeight; //设置高度
          //监听touchstart事件，touchmove事件，touchend事件等事件
          this.InitThis();
          this.clearArea();
        })
      },50)
    },
    colseSign() {},
    saveImageInfo() {
      var image = this.c.toDataURL("image/png"); //得到生成后的签名base64位  url 地址
      // console.log(image);
      let params = {
        contract_number: this.$route.query.contract_number,
        img_base64: image, //图片base6码
      };
      this.wxContractSignatureFun(params);
    },
    InitThis() {
      // 触摸屏
      var that = this;
      this.c.addEventListener(
        "touchstart",
        function (event) {
          // console.log(event);
          if (event.targetTouches.length == 1) {
            event.preventDefault(); // 阻止浏览器默认事件，重要
            var touch = event.targetTouches[0];
            this.mousePressed = true;
            that.Draw(
              !this.rotateType? touch.pageX - this.offsetLeft :touch.pageY ,
              !this.rotateType? touch.pageY - this.offsetTop :touch.pageX ,
              false
            );
          }
        },
        false
      );

      this.c.addEventListener(
        "touchmove",
        function (event) {
          if (event.targetTouches.length == 1) {
            event.preventDefault(); // 阻止浏览器默认事件，重要
            var touch = event.targetTouches[0];
            if (this.mousePressed) {
              that.Draw(
                !this.rotateType? touch.pageX - this.offsetLeft:touch.pageY ,
                !this.rotateType? touch.pageY - this.offsetTop:touch.pageX ,
                true
              );
            }
          }
        },
        false
      );

      this.c.addEventListener(
        "touchend",
        function (event) {
          if (event.targetTouches.length == 1) {
            event.preventDefault(); // 阻止浏览器默认事件，防止手写的时候拖动屏幕，重要
            // var touch = event.targetTouches[0];
            this.mousePressed = false;
          }
        },
        false
      );
      //   this.c.addEventListener(
      //     "touchcancel",
      //     function(event) {
      //       this.mousePressed = false;
      //     },
      //     false
      //   );

      // 鼠标
      // this.c.onmousedown = function (event) {
      //   this.mousePressed = true;
      //   that.Draw(
      //     !this.rotateType? event.pageX - this.offsetLeft:event.pageX - this.offsetLeft,
      //     !this.rotateType? event.pageY - this.offsetTop:event.pageY - this.offsetTop,
      //     false
      //   );
      // };

      // this.c.onmousemove = function (event) {
      //   console.log(event);
      //   if (this.mousePressed) {
      //     that.Draw(
      //       !this.rotateType? event.pageX - this.offsetLeft:event.pageX - this.offsetLeft,
      //       !this.rotateType? event.pageY - this.offsetTop: event.pageY - this.offsetTop,
      //       true
      //     );
      //   }
      // };

      // this.c.onmouseup = function (event) {
      //   this.mousePressed = false;
      // };
    },
    Draw(x, y, isDown) {
      if (isDown) {
        this.ctx.beginPath();
        this.ctx.strokeStyle = "#000"; //颜色
        this.ctx.lineWidth = 3; //线宽
        this.ctx.lineJoin = "round";
        this.ctx.lineMax = 10; //设置画笔最大线宽
        this.ctx.lineMin = 3; //设置画笔最小线宽
        this.ctx.linePressure = 1.2; //设置画笔笔触压力
        this.ctx.smoothness = 30; //设置画笔笔触大小变化的平滑度。
        this.ctx.moveTo(this.lastX, this.lastY);
        this.ctx.lineTo(x, y);
        this.ctx.closePath();
        this.ctx.stroke();
      }
      this.lastX = x;
      this.lastY = y;
    },
    clearArea() {
      console.log("清空画板");
      // Use the identity matrix while clearing the canvas
      this.ctx.setTransform(1, 0, 0, 1, 0, 0);
      this.ctx.clearRect(0, 0, this.ctx.canvas.width, this.ctx.canvas.height);
    },
    saveSign() {
      //提交签名
      this.checkEmpty(); //调用 表单非空验证
    },
    checkEmpty() {
      var c = document.getElementById("myCanvas"); // 获取html的canvas对象，我这个id="myCanvas"
      if (this.isCanvasBlank(c)) {
        this.$toast({message:"请签名",className:this.rotateType?'':'hpToast'});
        return;
      } else {
        console.log("提交签名");
        var image = this.c.toDataURL("image/png"); //得到生成后的签名base64位  url 地址
        console.log(image); //保存为图片base64 url
        this.$uploadAxios.post('upload/base64-upload', {data:image,fileName:'签名_'+new Date().getTime()+'.png'}).then(result =>{
          console.log(result);
          console.log(result.data);
        })
      }
    },
    //验证canvas画布是否为空函数
    isCanvasBlank(canvas) {
      var blank = document.createElement("canvas"); //系统获取一个空canvas对象
      blank.width = canvas.width;
      blank.height = canvas.height;
      return canvas.toDataURL() == blank.toDataURL(); //比较值相等则为空
    },
  },
};
</script>
<style lang="scss" scoped>
.sign-page {
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  flex-direction: column;
  .emtry-container {
    flex: 1;
  }
  .content {
    background: #ffffff;
    border-radius: 0.64rem 0.64rem 0 0;
    .title {
      height: 2.2rem;
      line-height: 2.2rem;
      padding: 0 0.6rem;
      font-size: 0.72rem;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #303133;
      text-align: center;
      position: relative;
      border-bottom: 1px solid #dddfe6;
      ::v-deep .close-icon {
        position: absolute;
        right: 0.6rem;
        top: 50%;
        padding: 0.1rem;
        transform: translate(0, -50%);
      }
    }
    .sign-wrap {
      margin: 0.8rem 0.6rem 1.2rem 0.6rem;
      background: #edeef2;
      border-radius: 0.2rem;
      height: 9.2rem;
      border: 1px dashed #838385;

      #myCanvas {
        // width: 100%;
        display: none;
        // height: 100%;
      }
    }
    .fix-btn {
      padding: 0 0.6rem 1.2rem 0.6rem;
      justify-content: space-between;
      position: relative;
      .fullScreen {
        width: 0.92rem;
        height: 0.92rem;
        background: url("~@/assets/img/rotate-icon.png") no-repeat;
        background-size: 100% 100%;
        position: absolute;
        top: -2.5rem;
        right: 1rem;
      }
      .btn-item {
        flex: 1;
      }
      .clear-btn,
      .comfirm-btn {
        margin-right: 0.8rem;
        height: 1.6rem;
        line-height: 1.6rem;
        border-radius: 0.8rem;
        border: 1px solid #49a7ff;
        font-size: 0.72rem;
        text-align: center;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #49a7ff;
      }
      .comfirm-btn {
        color: #ffffff;
        background: linear-gradient(180deg, #49c1ff 0%, #499fff 100%);
      }
    }
  }
  .horizontalScreen{
    display: flex;
    // flex-direction: column;
    border-radius: 0;
    width: 100vw;
    height: 100vh;
    // position: fixed;
    // transform: rotate(90deg) translate(39vw, 22vh);
    // transform: rotate(90deg);
    // transform-origin: 50vw 50vw;
    // left: -21vh;
    // top: 36vw;
    .sign-container{
      flex: 1;
      margin: 0.6rem 1.2rem 0.6rem 0.8rem;
      .sign-wrap{
        height: 100%;
        margin: 0;
      }
    }
    .emtry-container{
      display: none;
    }
    .sign-wrap{
      // height: auto;
      height: unset;
      flex: 1;
    }
    .title{
      padding: 0.6rem 0;
      width: 2.2rem;
      height: 100vh;
      box-sizing: border-box;
      .txt{
        margin-top: -0.6rem;
        padding: 0 0.6rem;
        width: 100vh;
        box-sizing: border-box;
        transform: rotate(-90deg);
        transform-origin: 50vh 50vh;
      }
    }
    .title, .bottom-btn{
      text-align: left;
      // writing-mode:vertical-;
      justify-content: flex-end;
      flex: 0 0 auto;
    }
    
    .bottom-btn{
      flex-direction: column;
      width: 1.6rem;
      padding: 0.6rem 1.2rem 0.6rem 0;
      .fix-btn {
        width: 100vh;
        box-sizing: border-box;
        justify-content: flex-end;
        transform: rotate(-90deg);
        transform-origin: 50vh 50vh;
        .btn-item{
          width: 6rem;
          flex: unset;
        }
      }
    } 
  }
}
</style>

<style>
.hpToast{
      transform: rotate(270deg) translate(0, -100%);
}
</style>